<template>
  <v-app>
    <div class="ma-5 quiz">
      <div class="d-flex justify-center mb-4">
        <v-img src="./assets/Nutrition-Logo.png" max-width="150px"></v-img>
      </div>
      <v-stepper :value="mainAppStep">
        <v-stepper-header>
          <v-stepper-step step="1" complete color="#ff684d">שלב א': מילוי השאלון</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="2" color="#ff684d">שלב ב': קבלת הטיפים</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-stepper v-model="current" vertical>
              <template v-for="question in questionsFromJson">
                <v-stepper-step
                  :key="`question-${question.step}`"
                  :complete="current > question.step"
                  :step="question.step"
                  editable
                  color="#ff684d"
                >{{ question.title }}</v-stepper-step>

                <v-stepper-content :key="`answer-${question.step}`" :step="question.step">
                  <v-card class="mb-4 pa-3" color="grey lighten-5">
                    <div class="d-md-flex justify-space-between">
                      <v-radio-group
                        v-model="question.selectedAnswer"
                        :mandatory="false"
                        @change="validation"
                      >
                        <v-radio
                          v-for="(ans,index) in question.answers"
                          :key="index"
                          :label="ans.answer"
                          :value="index"
                          color="#ff684d"
                          class="mb-md-4 mb-6"
                        ></v-radio>
                      </v-radio-group>
                      <img
                        :src="`http://nutrition-academy.co.il/quiz/quiz-img/${question.step}.jpg`"
                        :width="$vuetify.breakpoint.smAndDown ? '100%' : '500px'"
                        style="border-radius: 5px;"
                      />
                    </div>
                  </v-card>

                  <!-- <v-btn text>Cancel</v-btn> -->
                  <v-btn
                    v-if="current < questionsFromJson.length"
                    color="#ff684d"
                    @click="current++"
                    class="mb-2"
                    dark
                  >המשך</v-btn>
                  <v-btn
                    v-else
                    :disabled="isAllValid > 0 || isAllValid == null"
                    color="#ff684d"
                    @click="onSubmit"
                    class="white--text"
                  >סיום שאלון</v-btn>
                </v-stepper-content>
              </template>
            </v-stepper>
          </v-stepper-content>
          <v-stepper-content step="2">
            <div id="form" v-if="!isFormSubmitted">
              <h2>אנא מלאו פרטיכם לקבלת תוצאות השאלון והטיפים</h2>
              <SubmitForm @submitForm="submitForm" />
            </div>
            <div id="results" v-else>
              <h2 class="mb-3">ההמלצות שלי בהתבסס על תשובותייך</h2>
              <ul class="mr-5">
                <li v-for="(tip,index) in this.tipsToShow" :key="index" class="mb-3">
                  <b>{{ tip.que }}:</b>
                 {{ tip.tip }}
                </li>
              </ul>
              <h2 class="my-3">בנוסף, מצרפת המלצות אלו לקראת המבחן</h2>
              <ul class="mr-5">
                <li v-for="(tip,index) in this.defaultTips" :key="index" class="mb-3">{{ tip }}</li>
              </ul>
              <p class="mt-5">בהצלחה, שרון</p>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
  </v-app>
</template>


<script>
import questionsJson from "./questions.json";
import defaultTipsJson from "./defaultTips.json";
import SubmitForm from "./components/Form.vue";

export default {
  name: "App",
  components: { SubmitForm },
  data: () => ({
    mainAppStep: 1,
    current: 1,
    defaultTips: [],
    questionsFromJson: [],
    tipsToShow: [],
    isAllValid: null,
    isFormSubmitted: false
  }),
  created() {
    let currentNum = 1;

    for (let index = 0; index < questionsJson.length; index++) {
      let question = questionsJson[index];

      if (question.Num == currentNum) {
        if (question.Title) {
          this.questionsFromJson[currentNum - 1] = {
            step: question.Num,
            title: question.Title,
            answers: [
              {
                answer: question.Answer,
                tip: question.Tip
              }
            ],
            selectedAnswer: null,
            summary: question.Summary
          };
        } else {
          this.questionsFromJson[currentNum - 1].answers.push({
            answer: question.Answer,
            tip: question.Tip
          });
        }
      } else {
        if (index < questionsJson.length) {
          currentNum++;
          if (question.Title) {
            this.questionsFromJson[currentNum - 1] = {
              step: question.Num,
              title: question.Title,
              answers: [
                {
                  answer: question.Answer,
                  tip: question.Tip
                }
              ],
              selectedAnswer: null,
              summary: question.Summary
            };
          } else {
            this.questionsFromJson[currentNum - 1].answers.push({
              answer: question.Answer,
              tip: question.Tip
            });
          }
        }
      }
    }

    defaultTipsJson.forEach(tip => {
      this.defaultTips.push(tip.Tip);
    });
  },
  methods: {
    onSubmit() {
      console.log("submit");
      this.questionsFromJson.forEach(question => {
        if (question.selectedAnswer != null) {
          this.tipsToShow.push({
            que: question.summary,
            tip: question.answers[question.selectedAnswer].tip
          });
        }
      });
      this.mainAppStep = 2;
    },
    validation() {
      let flag = 0;
      this.questionsFromJson.forEach(question => {
        if (question.selectedAnswer == null) {
          flag++;
        }
      });
      this.isAllValid = flag;
    },
    async submitForm(payload) {
      let settings = payload;
      console.log(settings);
      //this.isFormSubmitted = true;

      let url = 'https://hook.integromat.com/ilqhckqrnwvvr4p2em8vf8ftxxy88jvq'

      try {
        const response = await fetch(
          url,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(settings)
          }
        );
        if (response.ok){
          this.isFormSubmitted = true;
        }
      }
      catch (err) {
          console.log(err)
      }
    }
  }
};
</script>

<style>
.v-application {
  font-family: "Assistant" !important;
  font-size: 1.2em;
}

@media only screen and (max-width: 959px) {
.v-stepper:not(.v-stepper--vertical) .v-stepper__content .v-stepper__label {
  display: flex !important;
  margin-right: 10px;
}

.v-stepper--vertical .v-stepper__content {
  margin-left: 0 !important;
}
}

.v-input .v-label {
  height: auto !important;
}

.v-label {
  font-size: 18px;
  color: rgba(0, 0, 0, 0.9) !important;
}

.v-stepper__content {
  border-left: 0px !important;
}

.v-input {
  text-align: right;
}

li {
  font-size: 19px;
  line-height: 1.8em;
  white-space: pre-wrap;
}
</style>